// extracted by mini-css-extract-plugin
export default {"categoryTitle":"categoryTitle__RrUXZ","innerFilter":"innerFilter__nTD4e"};